import { CSSObject } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getSupportHeaderTitleStyles = (theme: Theme): CSSObject => ({
    color: theme.palette.primary.dark,
});
